module.exports = __webpack_public_path__ + "static/img/20045B_1_R_20201022_fit.71b734e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_1_R_20201022_fit.png
// module id = JFKj
// module chunks = 0